module.exports = __webpack_public_path__ + "img/manyrobot-profile.848ef37f.svg";